import { TDashboardFilters, TDashboardFiltersResponse } from '../types'

export const formatDashboardFiltersResponse = (
  response: TDashboardFiltersResponse
): TDashboardFilters => ({
  health_systems: response.health_system_set ?? [],
  hospitals: response.hospital_set ?? [],
  led_by: response.led_by_set ?? [],
  user: response.user_set ?? [],
  contract_categories: response.category_set ?? [],
  portfolio: response.portfolio_set ?? []
})

export const formatDashboardFiltersToResponse = (
  filters: TDashboardFilters
): TDashboardFiltersResponse => ({
  health_system_set: filters.health_systems ?? [],
  hospital_set: filters.hospitals ?? [],
  led_by_set: filters.led_by ?? [],
  user_set: filters.user ?? [],
  category_set: filters.contract_categories ?? [],
  portfolio_set: filters.portfolio ?? []
})
